import { COUNTRY_VIEW_ERROR, COUNTRY_VIEW_POST_ERROR, COUNTRY_VIEW_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    results:[],
    success:false,
}, action) => {
    switch (action.type) {
    case COUNTRY_VIEW_SUCCESS:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false,
        ErrorMessage: 'Retrieve Success',
        success:true,
        results: action.payload
        };  
         
      case COUNTRY_VIEW_POST_ERROR:
        return {
            ...state, 
            error: state.error,
            loading:false,
            success: false,
            isSnackbarError: true,
            isSwitchSnackbarOn: true,
            ErrorMessage: "COUNTRY POST ERROR | CONTACT NETWORK ADMINISTRATOR",
        }
        break; 
    case COUNTRY_VIEW_ERROR:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: true,
        loading: false,
        ErrorMessage: action.payload,
        error:true,
        success:false
        };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/countryReducer.js